import { Navigate } from 'react-router-dom';
import { hasStoredSession } from '../utils/authSession';

export default function ProtectedRoute({ element }) {
  if (!hasStoredSession()) {
    return <Navigate to="/" replace />;
  }

  return element;
}
